<template>
  <vue-final-modal v-slot="{ close }">
    <div class="loginmodal">
      <div class="art" :class="level"><!-- agreeart warningart -->
        <span class="img"></span>
        <p v-html="$t(code)"></p>
        <div class="btn">
          <template v-if="type == 'confirm'">
            <button class="yes" @click="$emit('confirm', 'yes', close)">{{$t('front.button.yes')}}</button>
            <button class="no" @click="$emit('confirm', 'no', close)">{{$t('front.button.no')}}</button>
          </template>

          <template v-if="type == 'check'">
            <button class="yes" @click="$emit('check', 'ok', close)">{{$t('front.button.confirm')}}</button>
          </template>
        </div>
        <button class="closeart" type="button" aria-label="알림 닫기" @click="onClose(close)"><img src="@/assets/img/icon_cancel.png" alt="" /></button>
      </div>
    </div>
  </vue-final-modal>
</template>

<script>

import Alert from '@/components/common/Alert'

export default {
  name: 'AlertMobile',
  mixins: [Alert]
}
</script>

<style scoped>
button{cursor:pointer}.loginmodal{display:flex!important;align-items:center!important;justify-content:center!important;overflow:hidden!important;background:rgba(7,2,3,.84)!important;backdrop-filter:blur(6px)}.art{position:relative;box-sizing:border-box;width:290px;max-width:calc(100vw - 32px);margin:0;padding:31px 23px 24px;text-align:center;border:1px solid #70454b;border-radius:10px;background:radial-gradient(circle at 50% 0,rgba(132,49,61,.2),transparent 45%),#190b0e;box-shadow:0 20px 58px rgba(0,0,0,.65)}.art p{margin:15px 0 0;font-size:13px;font-weight:600;color:#f1e4d7;line-height:1.6;word-break:keep-all}.art .btn{display:flex;justify-content:center;gap:8px}.art .yes,.art .no{box-sizing:border-box;flex:1;height:42px;margin-top:22px;border-radius:4px;font-size:12px;font-weight:700}.art .img{display:block;width:43px;height:43px;margin:0 auto;background-position:center!important;background-repeat:no-repeat!important;background-size:contain!important;filter:sepia(1) saturate(.8) brightness(1.5)}.agreeart .img{background-image:url('~@/assets/img/agreeart.svg')}.warningart .img{background-image:url('~@/assets/img/warningart.svg')}.agreeart .yes,.warningart .yes{border:1px solid #d9ae5d;color:#1a090b;background:linear-gradient(135deg,#dfbd72,#9d682d)}.agreeart .no,.warningart .no{border:1px solid #664047;background:#271116;color:#cdbbb0}.closeart{position:absolute;right:10px;top:10px;width:32px;height:32px;padding:0;border:0;background:transparent;opacity:.72}.closeart img{width:13px;height:13px;margin:0;filter:sepia(1) brightness(1.4)}
</style>
<style scoped src="@/styles/header.css"></style>
<style scoped src="@/styles/common.css"></style>
<style scoped src="@/styles/subcommon.css"></style>
